const super_admin: any = [
  {
    name: 'Ведение полисов',
    icon: '',
    url: 'maintenance-policies',
    id: 'maintenance-policies',
    submenu: [],
  },
  {
    name: 'Ведение дел',
    icon: '',
    url: 'case-management',
    id: 'case-management',
    submenu: [],
  },
  {
    name: 'Пользователи',
    icon: '',
    url: 'users',
    id: 'users',
    submenu: [],
  },
  {
    name: 'Отчеты',
    icon: '',
    url: 'reports',
    id: 'report',
    submenu: [],
  },
  {
    name: 'Справочник',
    icon: 'IconHandbook',
    id: 'справочник',
    submenu: [
      {
        name: 'Страхователи',
        icon: '',
        url: 'insurer',
        id: 'insurer',
      },
      {
        name: 'Регионы',
        icon: '',
        url: 'area',
        id: 'regions',
      },
      {
        name: 'Страховые компании',
        icon: '',
        url: 'insurance-companies',
        id: 'insurance-companies',
      },
      {
        name: 'Страховые программы',
        icon: '',
        url: 'insurance-programs',
        id: 'insurance-programs',
      },
      {
        name: 'Медицинские учреждения',
        icon: '',
        url: 'medical-institutions',
        id: 'medical-institutions',
      },
      {
        name: 'Заболевания',
        icon: '',
        url: 'illness',
        id: 'illness',
      },
      {
        name: 'Медикаменты',
        icon: '',
        url: 'medicines',
        id: 'medicines',
      },
      {
        name: 'Медицинские услуги',
        icon: '',
        url: 'medical-services',
        id: 'medical-services',
      },
      {
        name: 'Валюты',
        icon: '',
        url: 'currencies',
        id: 'currencies',
      },
    ],
  },
];

const administrator: any = [
  {
    name: 'Ведение полисов',
    icon: '',
    url: 'maintenance-policies',
    id: 'maintenance-policies',
    submenu: [],
  },
  {
    name: 'Ведение дел',
    icon: '',
    url: 'case-management',
    id: 'case-management',
    submenu: [],
  },
  {
    name: 'Пользователи',
    icon: '',
    url: 'users',
    id: 'users',
    submenu: [],
  },
  {
    name: 'Справочник',
    icon: 'IconHandbook',
    id: 'справочник',
    submenu: [
      {
        name: 'Страхователи',
        icon: '',
        url: 'insurer',
        id: 'insurer',
      },
      {
        name: 'Регионы',
        icon: '',
        url: 'area',
        id: 'regions',
      },
      {
        name: 'Страховые компании',
        icon: '',
        url: 'insurance-companies',
        id: 'insurance-companies',
      },
      {
        name: 'Страховые программы',
        icon: '',
        url: 'insurance-programs',
        id: 'insurance-programs',
      },
      {
        name: 'Медицинские учреждения',
        icon: '',
        url: 'medical-institutions',
        id: 'medical-institutions',
      },
      {
        name: 'Заболевания',
        icon: '',
        url: 'illness',
        id: 'illness',
      },
      {
        name: 'Медикаменты',
        icon: '',
        url: 'medicines',
        id: 'medicines',
      },
      {
        name: 'Медицинские услуги',
        icon: '',
        url: 'medical-services',
        id: 'medical-services',
      },
      {
        name: 'Валюты',
        icon: '',
        url: 'currencies',
        id: 'currencies',
      },
    ],
  },
];

const operator: any = [
  {
    name: 'Ведение полисов',
    icon: '',
    url: 'maintenance-policies',
    id: 'maintenance-policies',
    submenu: [],
  },
  {
    name: 'Ведение дел',
    icon: '',
    url: 'case-management',
    id: 'case-management',
    submenu: [],
  },
  {
    name: 'Справочник',
    icon: 'IconHandbook',
    id: 'справочник',
    submenu: [
      {
        name: 'Страхователи',
        icon: '',
        url: 'insurer',
        id: 'insurer',
      },
      {
        name: 'Регионы',
        icon: '',
        url: 'area',
        id: 'regions',
      },
      {
        name: 'Страховые компании',
        icon: '',
        url: 'insurance-companies',
        id: 'insurance-companies',
      },
      {
        name: 'Страховые программы',
        icon: '',
        url: 'insurance-programs',
        id: 'insurance-programs',
      },
      {
        name: 'Медицинские учреждения',
        icon: '',
        url: 'medical-institutions',
        id: 'medical-institutions',
      },
      {
        name: 'Заболевания',
        icon: '',
        url: 'illness',
        id: 'illness',
      },
      {
        name: 'Медикаменты',
        icon: '',
        url: 'medicines',
        id: 'medicines',
      },
      {
        name: 'Медицинские услуги',
        icon: '',
        url: 'medical-services',
        id: 'medical-services',
      },
      {
        name: 'Валюты',
        icon: '',
        url: 'currencies',
        id: 'currencies',
      },
    ],
  },
];

export const data: any = {
  super_admin: super_admin,
  administrator: administrator,
  operator: operator,
};
